import styled, { css, keyframes } from 'styled-components'

export const GridSampleTemplate = styled.div`
  display: grid;
  ${p => p.jself && `justify-self: ${p.jself}`};
  ${p => p.gtemplate && `grid-template: ${p.gtemplate}`};
  ${p => p.ggap && `grid-gap: ${p.ggap}`};
`

export const GridArea = styled.section`
  grid-area: ${p => p.name};
  ${p => p.css};
`

const gridProfile = css`
  grid-template-columns: ${p => p.flip ? '645px 250px' : '250px 645px'};
  grid-template-rows: minmax(160px, auto);
`

const findLayout = css`
  grid-template-areas:
    "head"
    "body";
  @media (min-width: ${props => props.theme.mediaTriggerWidth}){
    ${gridProfile};
    grid-gap: ${props => props.theme.gGap};
    grid-template-areas:
      "menu body";
  }
`
const fadeIn = keyframes`
  from {opacity: 0.5;}
  to {opacity: 1;}
`

export const GridLayout = styled.div`
&:after {
content: "";
clear: both;
display: block;
}
  display: grid;
  animation: ${fadeIn} .25s linear;
  ${p => p.organizationProfile && organizationProfile};
  ${p => p.personProfile && personProfile};
  ${p => p.organizationOffice && organizationOffice};
  ${p => p.eventProfile && eventProfile};
  ${p => p.finder && findLayout};
`

const personProfile = css`
  grid-template-areas:
    "head"
    "body";
  @media (min-width: ${p => p.theme.mediaTriggerWidth}){
    ${gridProfile};
    grid-gap: ${p => p.theme.gGap};
    grid-template-areas:
      "menu head"
      "menu body";
  }
`

const eventProfile = css`
  @media (min-width: ${p => p.theme.mediaTriggerWidth}){
    grid-template-columns: 595px 300px;
    grid-template-rows: minmax(185px, auto);
    grid-gap: ${p => p.theme.gGap};
  
    grid-template-areas:
      "head head"
      "body menu";
  }
`

const organizationProfile = css`
  @media (min-width: ${p => p.theme.mediaTriggerWidth}){
    ${gridProfile};
    grid-gap: ${p => p.theme.gGap};

    grid-template-areas:
      "head head"
      "menu body";
  }

  @media (max-width: 944px){
    display: block;
  }
`
const organizationOffice = css`
  @media (min-width: ${p => p.theme.mediaTriggerWidth}){
    ${gridProfile};
    grid-gap: ${p => p.theme.gGap};
  
    grid-template-areas:
      "body menu";
  }
`
